// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPriorAuthorization {
    static getAttributeTypeMap() {
        return PharmacyBiPriorAuthorization.attributeTypeMap;
    }
}
PharmacyBiPriorAuthorization.discriminator = undefined;
PharmacyBiPriorAuthorization.additionalProperties = false;
PharmacyBiPriorAuthorization.attributeTypeMap = [
    {
        "name": "appealsContactFax",
        "baseName": "appealsContactFax",
        "type": "string"
    },
    {
        "name": "approvalNumber",
        "baseName": "approvalNumber",
        "type": "string"
    },
    {
        "name": "denialReason",
        "baseName": "denialReason",
        "type": "string"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "string"
    },
    {
        "name": "initiationDate",
        "baseName": "initiationDate",
        "type": "string"
    },
    {
        "name": "notificationMethod",
        "baseName": "notificationMethod",
        "type": "string"
    },
    {
        "name": "onFile",
        "baseName": "onFile",
        "type": "string"
    },
    {
        "name": "required",
        "baseName": "required",
        "type": "string"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "string"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "string"
    },
    {
        "name": "submissionDate",
        "baseName": "submissionDate",
        "type": "string"
    },
    {
        "name": "turnaroundTime",
        "baseName": "turnaroundTime",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPriorAuthorization.js.map